import { Select } from "@/atoms"
import { OptionRender } from "@/molecules/DescriptiveSelect"
import { findOptionsLabel, getScanTypeOptions, getShowOptions } from "./options"

import styles from "./TopInitiatorsDropdown.module.scss"

import type { PolicyResultTopInitiators } from "@/api/useScanHistory.types"
import type {
  DropdownTopInitiatorWidgetProps,
  Scanner
} from "./TopInitiatorWidget.types"

export const TopInitiatorsDropdown = (
  props: DropdownTopInitiatorWidgetProps
) => {
  const { filters, t } = props
  const scanTypeOptions = getScanTypeOptions(t)
  const showOptions = getShowOptions(t)

  return (
    <Select
      rootClassName={styles.topInitiatorsDropdown}
      value={filters}
      variant="borderless"
      options={[
        { label: t("scanScope"), options: scanTypeOptions },
        { label: t("show"), options: showOptions }
      ]}
      optionRender={OptionRender(filters)}
      labelRender={() => {
        const showTypeLabel = findOptionsLabel(showOptions, filters[0])

        return (
          <div
            className={styles.topInitiatorsDropdownLabel}
          >{`${showTypeLabel} (${filters[1]})`}</div>
        )
      }}
      onSelect={(value) => {
        const isScanType = scanTypeOptions.some(
          (option) => option.value === value
        )

        if (isScanType) props.setFilters((prev) => [prev[0], value as Scanner])
        else
          props.setFilters((prev) => [
            value as PolicyResultTopInitiators,
            prev[1]
          ])
      }}
    />
  )
}
